var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "file-manager-container" },
    [
      _vm.fileManagerSpinner
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer-file-manager-component",
            attrs: { loadingText: _vm.spinnerText.actual },
          })
        : _vm._e(),
      !_vm.isOpeningFile
        ? _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c("ejs-filemanager", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showDocumentDetail && !_vm.showFolderDetail,
                    expression: "!showDocumentDetail && !showFolderDetail",
                  },
                ],
                ref: "fileManager",
                attrs: {
                  id: "file-manager",
                  locale: _vm.locale,
                  view: _vm.view,
                  allowDragAndDrop: true,
                  ajaxSettings: _vm.ajaxSettings,
                  uploadSettings: _vm.uploadSettings,
                  detailsViewSettings: _vm.detailsViewSettings,
                  contextMenuSettings: _vm.contextMenuSettings,
                  toolbarSettings: _vm.toolbarSettings,
                  created: _vm.onFileManagerCreated,
                  beforeSend: _vm.onFileManagerBeforeSend,
                  beforeImageLoad: _vm.onFileManagerBeforeImageLoad,
                  beforePopupOpen: _vm.onFileManagerBeforeDialogOpen,
                  success: _vm.onFileManagerAfterSuccess,
                  failure: _vm.onFileManagerFailure,
                  fileDragStart: _vm.onFileManagerDragStart,
                  fileDragStop: _vm.onFileManagerDragStop,
                  fileDragging: _vm.onFileManagerDragging,
                  fileLoad: _vm.onFileLoad,
                  fileSelect: _vm.onFileSelect,
                  fileOpen: _vm.onFileOpen,
                  menuClick: _vm.onContextMenuClick,
                  menuOpen: _vm.onContextMenuOpen,
                  toolbarCreate: _vm.onToolbarCreate,
                  toolbarClick: _vm.onToolbarClick,
                  popupOpen: _vm.onPopupOpen,
                  popupClose: _vm.onPopUpClose,
                  height: _vm.height,
                  path: _vm.path,
                  selectedItems: _vm.selectedItems,
                  sortBy: _vm.sortBy,
                  sortOrder: _vm.sortOrder,
                },
              }),
              _c("DocumentOnline"),
              _vm.canDropFolder &&
              _vm.fileManagerInstance &&
              _vm.isDroppableFromCwd
                ? _c("UploaderComponent", {
                    key: _vm.componentKey,
                    attrs: {
                      currentState: _vm.currentState,
                      uploadSettings: _vm.uploadSettings,
                      fileManagerInstance: _vm.fileManagerInstance,
                    },
                  })
                : _vm._e(),
              !_vm.isTemplateMode && _vm.idEntityType
                ? _c("TemplateSelectorComponent", {
                    attrs: {
                      showDialog: _vm.showTemplateDialog,
                      idEntityType: _vm.idEntityType,
                    },
                    on: {
                      closeTemplateDialog: _vm.closeTemplateDialog,
                      generateTemplateDialog: _vm.generateTemplateDialog,
                    },
                  })
                : _vm._e(),
              _vm.showDocumentDetail && !_vm.isTemplateMode
                ? _c("FileManagerEditDocument", {
                    attrs: {
                      idDocument: _vm.idDocument,
                      idEntity: _vm.idEntity,
                      idEntityType: _vm.idEntityType,
                      idEntityTypeOld: _vm.idEntityTypeOld,
                      source: _vm.documentSource,
                      firmaStatus: _vm.firmaStatusDoc,
                      basePath: _vm.currentDocumentFolderPath,
                      editDocumentMode: _vm.editMode,
                      allDataLoaded: _vm.everythingLoaded,
                      permissionsEntity: _vm.permissionsEntity,
                    },
                    on: {
                      close: _vm.onCloseDocumentDetail,
                      "on-save-document-ok": _vm.onSaveDocumentOk,
                      "on-save-document-fail": _vm.onSaveDocumentFail,
                      "on-save-intervener-ok": _vm.onSaveIntervenerOk,
                      "on-save-v-fail": _vm.onSaveIntervenerFail,
                      "on-remove-document": _vm.onDocumentRemoveAction,
                      showForm: _vm.onShowForm,
                      documentInitForm: _vm.onDocumentInitForm,
                    },
                  })
                : _vm._e(),
              _vm.showFolderDetail
                ? _c("FileManagerEditFolder", {
                    attrs: {
                      idDocument: _vm.idDocument,
                      idEntity: _vm.idEntity,
                      idEntityType: _vm.idEntityType,
                      nameDocument: _vm.documentName,
                      basePath: _vm.currentDocumentFolderPath,
                      editDocumentMode: _vm.editMode,
                      allDataLoaded: _vm.everythingLoaded,
                      permissionsEntity: _vm.permissionsEntity,
                    },
                    on: {
                      close: _vm.onCloseDocumentDetail,
                      "on-save-document-ok": _vm.onSaveFolderOk,
                      "on-save-document-fail": _vm.onSaveDocumentFail,
                      showForm: _vm.onShowForm,
                    },
                  })
                : _vm._e(),
              _vm.showDocumentDetail && _vm.isTemplateMode
                ? _c("FileManagerEditTemplate", {
                    attrs: {
                      idDocument: _vm.idDocument,
                      idEntity: _vm.idEntity,
                      idEntityType: _vm.idEntityType,
                      templateType: _vm.idEntityTypeAdditional,
                      basePath: _vm.currentBasePath,
                      id: _vm.templateId,
                      context: _vm.templateModeContext,
                    },
                    on: {
                      close: _vm.onCloseDocumentDetail,
                      "on-save-document-ok": _vm.onSaveDocumentOk,
                      "on-save-document-fail": _vm.onSaveDocumentFail,
                      "on-save-intervener-ok": _vm.onSaveIntervenerOk,
                      "on-save-v-fail": _vm.onSaveIntervenerFail,
                      "on-remove-document": _vm.onDocumentRemoveAction,
                      showForm: _vm.onShowForm,
                      documentInitForm: _vm.onDocumentInitForm,
                    },
                  })
                : _vm._e(),
              _c("ejs-contextmenu", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showDocumentDetail,
                    expression: "!showDocumentDetail",
                  },
                ],
                ref: "documentContextMenu",
                attrs: {
                  id: "action-add-document-context-menu",
                  items: _vm.actionAddContextMenuDocumentItems,
                  select: _vm.onActionAddClick,
                  beforeOpen: _vm.onBeforeOpenContextMenu,
                },
              }),
              _c("ejs-contextmenu", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showDocumentDetail,
                    expression: "!showDocumentDetail",
                  },
                ],
                ref: "templateContextMenu",
                attrs: {
                  id: "action-add-template-context-menu",
                  items: _vm.actionAddContextMenuTemplateItems,
                  select: _vm.onActionAddClick,
                  beforeOpen: _vm.onBeforeOpenContextMenu,
                },
              }),
              _c("OfficeContextMenuComponent", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showDocumentDetail,
                    expression: "!showDocumentDetail",
                  },
                ],
                attrs: { configMode: _vm.openMSOfficeConfigMode },
                on: { saveConfig: _vm.onSaveGridConfig },
              }),
              _c("PromptDialogComponent", {
                attrs: {
                  title: _vm.saveAsZipText,
                  isOpened: _vm.openedSaveAsZipDialog,
                  formSchema: _vm.saveAsZipDialogFormSchema,
                  context: _vm.context,
                  formFieldValues: _vm.zipFormData,
                },
                on: { "execute-action": _vm.executeSaveAsZipDialogAction },
              }),
              _c("PreviewComponent", {
                ref: "preview",
                attrs: {
                  documentPreview: { id: 0, type: null },
                  fileManagerInstance: _vm.fileManagerInstance,
                },
              }),
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "file-manager-message" }, [
              _vm._v(_vm._s(_vm.openingFileText)),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }